__webpack_require__.p = "/widget/";